import React from 'react';
import {StyleSheet, View} from 'react-native';
import type {Meta, StoryObj} from '@storybook/react-native-web-vite';

import {Shop} from '../models/middleware';

import GiftCardStoreCard from './GiftCardStoreCard';

const makeShop = (overrides: Partial<Shop> & Pick<Shop, 'name' | 'store_number'>): Shop =>
  ({
    distance: 1.0,
    delivery_available: false,
    pickup_available: true,
    ...overrides,
    address: {
      lines: ['706 Main Street'],
      locality: 'Kangaroo Point',
      administrative_area: 'qld',
      postal_code: '4169',
      ...(overrides.address ?? {}),
    } as Shop['address'],
  }) as unknown as Shop;

const meta = {
  title: 'Components/Gift Cards/Store Card',
  component: GiftCardStoreCard,
  decorators: [
    Story => (
      <View style={styles.frame}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof GiftCardStoreCard>;

export default meta;

type Story = StoryObj<typeof meta>;

export const InStoreOnly: Story = {
  args: {
    item: makeShop({
      store_number: '001',
      name: 'Pineapple Hotel',
      distance: 1.0,
      instoreGiftCards: 'Live',
      pickup_available: false,
      delivery_available: false,
    }),
  },
};

export const OnlineOnly: Story = {
  args: {
    item: makeShop({
      store_number: '002',
      name: 'MT Gravatt Cellars',
      distance: 8.1,
      pickup_available: true,
      delivery_available: false,
      address: {
        lines: ['1226 Logan Road'],
        locality: 'Holland Park',
        administrative_area: 'qld',
        postal_code: '4121',
      } as Shop['address'],
    }),
  },
};

/** DIS-1460: ecommerce outside liquor delivery radius — Online + Pick up; Delivery off. */
export const SevenMileBarOutsideDeliveryRadius: Story = {
  args: {
    item: makeShop({
      store_number: 'SMB001',
      name: 'Seven Mile Bar',
      distance: 12.4,
      instoreGiftCards: 'Live',
      pickup_available: true,
      delivery_available: false,
    }),
  },
};

export const OldSpotPickupOnly: Story = {
  args: {
    item: makeShop({
      store_number: 'C000129699',
      name: 'OLD SPOT HOTEL',
      distance: 2.1,
      pickup_available: true,
      delivery_available: false,
    }),
  },
};

export const SmithfieldPickupAndDelivery: Story = {
  args: {
    item: makeShop({
      store_number: 'C000129752',
      name: 'SMITHFIELD HOTEL',
      distance: 3.4,
      pickup_available: true,
      delivery_available: true,
    }),
  },
};

export const AllOptions: Story = {
  args: {
    item: makeShop({
      store_number: '003',
      name: 'Boondall Cellars',
      distance: 13.4,
      instoreGiftCards: 'Live',
      pickup_available: true,
      delivery_available: true,
      address: {
        lines: ['Cnr Beams And Sandgate Rds'],
        locality: 'Boondall',
        administrative_area: 'qld',
        postal_code: '4034',
      } as Shop['address'],
    }),
  },
};

const styles = StyleSheet.create({
  // Frame fills the storybook content area so the card renders at the
  // actual viewport width (matches what the real app shows on the same
  // viewport). No maxWidth.
  frame: {
    backgroundColor: '#FFFFFF',
    paddingVertical: 16,
    width: '100%',
  },
});
